module.exports = __webpack_public_path__ + "static/media/9.9dc41e2f.svg";